import  {__extends} from './eXcell';
import eXcell_edn from './eXcell_edn';

var eXcell_switch = (function (_super) {
    __extends(eXcell_switch, _super);
    function eXcell_switch(cell) {
        _super.call(this);
       
        this.base = eXcell_edn;
        this.base(cell);
    }
    eXcell_switch.prototype.getValue = function () {
        return this.cell.innerText;
    };
    eXcell_switch.prototype.isDisabled = function () {
        return true;
    };
    eXcell_switch.prototype.edit = function () {
        return false;
    };
    return eXcell_switch;
})(eXcell_edn);
eXcell_switch.prototype.setValue = function (val) {
    var switchItem = this.grid.switchAry[this.cell._cellIndex];
    var jsonMap = {};
    //根据items里面获取相应的值
    if (switchItem != null&&switchItem!=""&&typeof(switchItem)==='object') {
        if (switchItem.items == null) {
            switchItem.items = [
                { label: "启用", value: "true" },
                { label: "停用", value: "false" }
            ];
        }
        switchItem.items.forEach(function (item) {
            jsonMap[item["value"]] = item["label"];
        });
    }
    val = jsonMap[val] || val;
    this.cell.innerHTML = this.grid._aplNF(val, this.cell._cellIndex);
};
window.eXcell_switch = eXcell_switch;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_switch.js